module.exports = __webpack_public_path__ + "7a50b8107e6c2168496c9580dfd0be94.fbx";